import axios from "axios";
import { Toaster } from "react-hot-toast";
import { QueryClient, QueryClientProvider } from "react-query";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./assets/css/App.css";
import CommonPage from "./pages/CommonPage";
import DashBoard from "./pages/DashBoard";
import LogIn from "./pages/LogIn";
import OrderDetail from "./pages/OrderDetail";

// Attach the customer JWT to every outgoing axios request
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("fxryToken");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Toaster />
        <Routes>
          {/* <Route path="/*" element={<UnderConstruction />} /> */}
          <Route path="/" element={<LogIn />} />
          <Route path="/dashboard" element={<DashBoard />} />
          <Route path="/past" element={<DashBoard />} />
          <Route path="/canceled" element={<DashBoard />} />
          <Route exact path="/orders/:orderId" element={<OrderDetail />} />
          <Route path="/payment-methods" element={<CommonPage />} />
          <Route path="/my-address" element={<CommonPage />} />
          <Route path="/contact-us" element={<CommonPage />} />
          <Route path="/settings" element={<CommonPage />} />
          <Route path="/log-in" element={<LogIn />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
